import type { RemovePlanElement } from "./types";

export const removePlanElement: RemovePlanElement = ({
  plan,
  groupLabel,
  elementId,
}) => {
  const groupElements = plan.groupedElements.byGroupId[groupLabel] ?? [];
  const removedElement = groupElements.find((e) => e.id === elementId);
  const newGroupElements = groupElements.filter((e) => e.id !== elementId);
  const isLastInGroup = newGroupElements.length === 0;

  const byGroupId = { ...plan.groupedElements.byGroupId };
  if (isLastInGroup) {
    delete byGroupId[groupLabel];
  } else {
    byGroupId[groupLabel] = newGroupElements;
  }

  const groupIds = isLastInGroup
    ? plan.groupedElements.groupIds.filter((id) => id !== groupLabel)
    : plan.groupedElements.groupIds;

  const groupMeta = isLastInGroup
    ? Object.fromEntries(
        Object.entries(plan.groupMeta).filter(([key]) => key !== groupLabel),
      )
    : plan.groupMeta;

  const all = removedElement
    ? {
        ...plan.groupedElements.all,
        count: Math.max(
          0,
          plan.groupedElements.all.count - removedElement.multiplier,
        ),
      }
    : plan.groupedElements.all;

  return {
    ...plan,
    groupedElements: {
      ...plan.groupedElements,
      byGroupId,
      groupIds,
      all,
    },
    groupMeta,
  };
};
